import { CopyOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { copyToClipboard } from "../copyToClipboard";

export const useColumns = (showModal) => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Booking ID",
      dataIndex: "bookingId",
      key: "bookingId",
      render: (bookingId) => (
        <div>
          {bookingId}
          <Tooltip title="Copy Booking ID">
            <CopyOutlined
              style={{ marginLeft: 3, color: "#1890ff", cursor: "pointer" }}
              onClick={() => copyToClipboard(bookingId)}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Room Booked",
      dataIndex: "rooms",
      key: "rooms",
      render: (rooms) => rooms.map((room) => room.room).join(", "),
    },
    {
      title: "Check-In",
      dataIndex: "fromdate",
      key: "fromdate",
    },
    {
      title: "Check-Out",
      dataIndex: "todate",
      key: "todate",
    },
    { title: "Guest Name", dataIndex: "guestName", key: "guestName" },
    {
      title: "Total Amount",
      dataIndex: "totalamount",
      key: "totalamount",
      render: (totalamount) => <strong>{totalamount}</strong>, // Bold the total amount
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      key: "transactionId",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "";
        let text = "";

        switch (status) {
          case "Booked":
            color = "#52c41a"; // Green for booked
            text = "Booked";
            break;
          case "Cancelled":
            color = "#ff4d4f"; // Red for cancelled
            text = "Cancelled";
            break;
          default:
            color = "#faad14"; // Yellow for other statuses
            text = status;
            break;
        }

        return <span style={{ color }}>{text}</span>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <div>
          <Button onClick={() => showModal(record)} style={{ marginRight: 8 }}>
            View Details
          </Button>
          <Button
            type="link"
            onClick={() => navigate("/admin/retrieve-card-input")}
          >
            Retrieve Card
          </Button>
        </div>
      ),
    },
  ];
  return {
    columns,
  };
};
